import router from '@/router'
import NProgress from 'nprogress'
import store from './store'
import 'nprogress/nprogress.css'
import { getToken } from './utils/token'

NProgress.configure({
  showSpinner: false
})

// 白名单
const whiteList = ['/', '/introduction', '/dynamic', '/scoreQuery', '/certificateQuery', '/signUp', '/password', '/personal', '/flowPath', '/inviteMembers']

router.beforeEach(async (to, from, next) => {
  NProgress.start()
  if (!store.state.user.competId) {
    store.dispatch('GetCompetId')
  }
  if (getToken()) {
    if (to.path == 'signUp') {
      next('/')
    } else {
      next()
    }
  } else {
    // 没有token
    // 在免登录白名单，直接进入
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next({path : '/signUp'})
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})


// WEBPACK FOOTER //
// ./src/permission.js